<template>
  <div class="col-4 pt-3">
    <a :href="link_url">
      <img class="corner-logo" :src="logo_url" :alt="$route.params.organization_name">
    </a>
  </div>
</template>

<script>
  export default {
    props: {
             logo_url: String,
             link_url: String
           }
    }
</script>

<style scoped>

.corner-logo {
  height: 7em;
  width: auto;
  margin-left: 3em;
}

</style>